function Clothes({anyWordClothes, addFunction}){
    return(
        <div className="products">
            {anyWordClothes.map(thing => {
                const {id, name, price, image} = thing;
                return(
                    
                        <div key={id} className="product-card">
                            <img src={image} alt={name} width="400px" height="500px"/>
                            <div className="product-info">
                                <h3>{name}</h3>
                                <h4>$ {price}</h4>
                                <button className="btn-add" onClick={addFunction}>
                                Add to Cart
                            </button>
                        </div>
                        </div>
                        
                )
            })}
        </div>
    )
}
export default Clothes;